import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
async function getModels(variables) {
  const request = await $voixNuxtApi(
    `/api/admin/voix/models`
  );
  return request;
}
async function getModelData(query, variables) {
  const params = new URLSearchParams(Object.assign({}, variables)).toString();
  const url = `${query}?${params.toString()}`;
  const request = await $voixNuxtApi(url);
  return request;
}
export { getModels, getModelData };
